/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cruitive_UpdatedInputs */



/**
* | output |
* | --- |
* | "Cruitive has been updated" |
*
* @param {Cruitive_UpdatedInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const cruitive_updated = /** @type {((inputs?: Cruitive_UpdatedInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cruitive_UpdatedInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Cruitive has been updated")
	return /** @type {LocalizedString} */ ("Cruitive har uppdaterats")
});